module.exports = __webpack_public_path__ + "static/media/KBS.98714ed5.png";